import { Box, Paper, Stack, Typography } from '@mui/material';
import type { Cn01FormStatusItem } from '~/apis/cn01PlanterApi';
import { formatStatusCreatedAt } from '../cn01StatusUtils';
import { Cn01StatusTracker } from './Cn01StatusTracker';

type Cn01ApplicationStatusCardProps = {
  item: Cn01FormStatusItem;
};

export function Cn01ApplicationStatusCard({ item }: Cn01ApplicationStatusCardProps) {
  const submittedDate = formatStatusCreatedAt(item.createdAt);

  return (
    <Paper
      elevation={2}
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
        maxWidth: 900,
        width: '100%',
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'flex-start' }}
        spacing={1}
        sx={{ mb: 2 }}
      >
        <Box>
          <Typography
            variant="overline"
            sx={{ color: 'text.secondary', letterSpacing: 1, lineHeight: 1.2 }}
            fontWeight={900}
            fontSize={15}
          >
            Application
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.5, wordBreak: 'break-all' }}
            fontSize={13}
          >
            Ref Number:<b style={{ fontWeight: 700 }}> {item.refNo?.trim() || '—'}</b>
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 1, lineHeight: 1.2 }}
            fontSize={13}
          >
            Permit Number: <b style={{ fontWeight: 700 }}> {item.permitNo?.trim() || '—'}</b>
          </Typography>
        </Box>
        <Box sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
          <Typography variant="body2" color="text.secondary">
            Submitted {submittedDate}
          </Typography>
        </Box>
      </Stack>

      <Cn01StatusTracker status={item.status} />
    </Paper>
  );
}
